import { Injectable } from '@angular/core';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import * as assignmentsActions from '../actions/assignments.actions';
import { map, catchError, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { MwAssignmentsApiService } from 'app/services/assignments-api.service';
import * as notifyActions from 'app/store/general/actions/notify.actions';

@Injectable()
export class AssignmentsEffects {
  loadAssignments$ = createEffect(() =>
    this.actions$.pipe(
      ofType(assignmentsActions.loadAssignments),
      switchMap(({ loadOptions }) =>
        this.assignmentsApiService.getAssignments(loadOptions).pipe(
          map((payload) =>
            assignmentsActions.loadAssignmentsSuccess({ payload })
          ),
          catchError((error) =>
            of(assignmentsActions.loadAssignmentsFailed({ error }))
          )
        )
      )
    )
  );

  createAssignment$ = createEffect(() =>
    this.actions$.pipe(
      ofType(assignmentsActions.createAssignment),
      switchMap(({ assignment }) =>
        this.assignmentsApiService.createAssignment(assignment).pipe(
          switchMap((response) => [
            assignmentsActions.createAssignmentSuccess({
              assignment: response,
            }),
            notifyActions.notifySuccess({
              notification: {
                phrase: 'OPERATION.add_assignment_successful',
              },
            }),
          ]),
          catchError((error) =>
            of(assignmentsActions.createAssignmentFailed({ error }))
          )
        )
      )
    )
  );

  updateAssignment$ = createEffect(() =>
    this.actions$.pipe(
      ofType(assignmentsActions.updateAssignment),
      switchMap(({ assignment }) =>
        this.assignmentsApiService.updateAssignment(assignment).pipe(
          switchMap((response) => [
            assignmentsActions.updateAssignmentSuccess(),
            notifyActions.notifySuccess({
              notification: {
                phrase: 'OPERATION.edit_assignment_successful',
              },
            }),
          ]),
          catchError((error) =>
            of(assignmentsActions.updateAssignmentFailed({ error }))
          )
        )
      )
    )
  );

  deleteAssignment$ = createEffect(() =>
    this.actions$.pipe(
      ofType(assignmentsActions.deleteAssignment),
      switchMap(({ assignment }) =>
        this.assignmentsApiService.deleteAssignment(assignment).pipe(
          switchMap(() => [
            assignmentsActions.deleteAssignmentSuccess(),
            notifyActions.notifySuccess({
              notification: {
                phrase: 'OPERATION.delete_assignment_successful',
              },
            }),
          ]),
          catchError((error) =>
            of(assignmentsActions.deleteAssignmentFailed({ error }))
          )
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private assignmentsApiService: MwAssignmentsApiService
  ) {}
}
